import { useCallback, useContext } from 'react';

import { TourContext } from './TourContext';
import type { TourTargetId } from './tourTypes';

export function useTourTarget(id: TourTargetId) {
  const context = useContext(TourContext);

  return useCallback(
    (element: HTMLElement | null) => {
      context?.registerTarget(id, element);
    },
    [context, id],
  );
}
